<markdown class="variable-binding" [data]="imprintModel?.text"></markdown>